import { render, staticRenderFns } from "./UserOrdersTable.vue?vue&type=template&id=501c0c59&scoped=true&"
import script from "./UserOrdersTable.vue?vue&type=script&lang=js&"
export * from "./UserOrdersTable.vue?vue&type=script&lang=js&"
import style0 from "./UserOrdersTable.vue?vue&type=style&index=0&id=501c0c59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501c0c59",
  null
  
)

export default component.exports